export default __webpack_public_path__ + "static/media/dictionary_rgb(133,133,133).3833fd1b.svg";